module.exports = __webpack_public_path__ + "scan.2efba815.png";


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/NewPayment/assets/scan.png
// module id = ByhE
// module chunks = 0